module.exports = __webpack_public_path__ + "img/gb834.prt.e4819dc8.jpg";